import React from 'react';
import ManagedWindow from './ManagedWindow';
import hasAncestor from '../../js/hasAncestor';
import './WindowManager.css';

const windowWidth = window.innerWidth || document.body.clientWidth;
const DEFAULT_WIDTH = Math.min(windowWidth * 0.6, 600);
const DEFAULT_OFFSETX = (windowWidth - DEFAULT_WIDTH) / 2;
const DEFAULT_OFFSETY = 40;
const DEFAULT_WINDOW_OFFSET = 0;

const isDraggable = (target) => {
    if (hasAncestor(target, el => el.classList.contains('WindowTitleButton'))) {
        return false;
    }
    return hasAncestor(target, el => el.classList.contains('Window-title'));
};

class WindowManager extends React.Component {
    constructor(props) {
        super(props);
        const numWindows = React.Children.count(props.children);
        this.state = {
            active: numWindows - 1,
            maxIndex: numWindows - 1,
            draggable: false,
            windows: React.Children.map(props.children, (_, i) => ({
                index: i,
                top: i * DEFAULT_WINDOW_OFFSET + DEFAULT_OFFSETY,
                left: i * DEFAULT_WINDOW_OFFSET + DEFAULT_OFFSETX,
                width: DEFAULT_WIDTH
            }))
        };
    }
    onWindowMouseDown(i, e) {
        let draggable = false
        if (isDraggable(e.target)) {
            draggable = {
                pageX: e.pageX,
                pageY: e.pageY
            };
        }
        const maxIndex = this.state.maxIndex + 1;
        const windows = this.state.windows;
        windows[i].index = maxIndex;
        this.setState({
            active: i,
            maxIndex,
            windows,
            draggable
        });
    }
    onMouseUp = () => {
        this.setState({
            draggable: false
        });
    }
    onMouseMove = (e) => {
        const draggable = this.state.draggable;
        if (draggable) {
            const diffX = draggable.pageX - e.pageX;
            const diffY = draggable.pageY - e.pageY;
            const windows = this.state.windows;
            const active = this.state.active;
            windows[active].top -= diffY;
            windows[active].left -= diffX;
            this.setState({
                draggable: {
                    pageX: e.pageX,
                    pageY: e.pageY
                },
                windows
            });
        }
    }
    render() {
        const windows = React.Children.map(this.props.children, (window, i) => {
            return (
                <ManagedWindow active={i === this.state.active}
                               {...this.state.windows[i]}
                               onMouseDown={this.onWindowMouseDown.bind(this, i)}>
                    {window}
                </ManagedWindow>
            );
        });
        return (
            <div className="WindowManager"
                 onMouseMove={this.onMouseMove}
                 onMouseUp={this.onMouseUp}>
                {windows}
            </div>
        );
    }
}

export default WindowManager;



// WEBPACK FOOTER //
// ./src/components/WindowManager/index.jsx